export default {
    data() {
        return {
            valid: {
                subscriptionPlan: false,
                country: false,
                name: false,
                app_name: false,
                address: false,
                vatNumber: false,
                email: false,
                primaryPhone: false,
                tos: false,
                marketing: false,
                fullname: false,
                mobile: false,
                countryCode: false
            },
            success: {
                subscriptionPlan: false,
                country: false,
                name: false,
                app_name: false,
                address: false,
                vatNumber: false,
                email: false,
                primaryPhone: false,
                tos: false,
                marketing: false,
                fullname: false,
                mobile: false,
                countryCode: false
            },
            error: {
                subscriptionPlan: "",
                country: "",
                name: "",
                app_name: "",
                address: "",
                vatNumber: "",
                email: "",
                primaryPhone: "",
                tos: "",
                marketing: "",
                fullname: "",
                mobile: "",
                countryCode: ""
            },
            errorMessages: {
                subscriptionPlanRequired: {
                    el: "Απαιτείται Σχέδιο Συνδρομής",
                    en: "Subscription Plan is required",
                    it: "È richiesto un piano di abbonamento"
                },
                countryRequired: {
                    el: "Απαιτείται Χώρα",
                    en: "Country is required",
                    it: "È richiesto il paese"
                },
                nameRequired: {
                    el: "Απαιτείται Όνομα Καταστήματος",
                    en: "Store Name is required",
                    it: "È richiesto il nome del negozio"
                },
                appNameRequired: {
                    el: "Απαιτείται Όνομα Εφαρμογής Καταστήματος",
                    en: "Store App Name is required",
                    it: "È richiesto il nome dell'app del negozio"
                },
                nameLength: {
                    el:
                        "Το Όνομα Καταστήματος πρέπει να έχει τουλάχιστον 5 χαρακτήρες",
                    en: "Store Name must be at least 5 characters long",
                    it:
                        "Il nome del negozio deve essere lungo almeno 5 caratteri"
                },
                addressRequired: {
                    el: "Απαιτείται Διεύθυνση",
                    en: "Address is required",
                    it: "È richiesto l'indirizzo"
                },
                addressIsPostal: {
                    el:
                        "Παρακαλώ επιλέξτε μια διεύθυνση που έχει ταχυδρομικό κώδικα",
                    en: "Please select an address that has a postal code",
                    it:
                        "Si prega di selezionare un indirizzo che abbia un codice postale"
                },
                vatNumberRequired: {
                    el: "Απαιτείται Αριθμός ΑΦΜ",
                    en: "Vat Number is required",
                    it: "È richiesto il numero di partita IVA"
                },
                vatNumberLength: {
                    el: "Ο Αριθμός ΑΦΜ πρέπει να έχει από 9 εώς 12 χαρακτήρες",
                    en: "Vat Number must be from 9 to 12characters long",
                    it: "Il numero di partita IVA deve avere una lunghezza compresa tra 9 e 12 caratteri."
                },
                emailRequired: {
                    el: "Απαιτείται E-mail",
                    en: "E-mail is required",
                    it: "È richiesta l'e-mail"
                },
                emailValid: {
                    el: "Το E-mail πρέπει να είναι έγκυρο",
                    en: "E-mail must be valid",
                    it: "L'e-mail deve essere valida"
                },
                primaryPhoneRequired: {
                    el: "Απαιτείται Κύριο Τηλέφωνο",
                    en: "Primary Phone is required",
                    it: "È richiesto il telefono principale"
                },
                primaryPhoneLength: {
                    el: "Το Κύριο Τηλέφωνο πρέπει να έχει μήκος μεταξύ 7 και 12 χαρακτήρων.",
                    en: "Primary Phone must be between 7 and 12 characters long",
                    it: "Il telefono principale deve avere una lunghezza compresa tra 7 e 12 caratteri."
                },
                fullnameRequired: {
                    el: "Απαιτείται Πλήρες Όνομα",
                    en: "Full Name is required",
                    it: "È richiesto il nome completo"
                },
                mobileRequired: {
                    el: "Απαιτείται Κινητό",
                    en: "Mobile is required",
                    it: "È richiesto il cellulare"
                },
                mobileLength: {
                    el: "Το κινητό χρήστη πρέπει να έχει μήκος μεταξύ 7 και 12 χαρακτήρων.",
                    en: "User Mobile must be between 7 and 12 characters long",
                    it: "Il cellulare dell'utente deve avere una lunghezza compresa tra 7 e 12 caratteri."
                },
                countryCodeRequired: {
                    el: "Απαιτείται κωδικός χώρας",
                    en: "Country code is required",
                    it: "Il codice paese è richiesto"
                },
            }
        };
    },

    computed: {
        formValid() {
            if (this.userDetails.new_manager) {
                return (
                    this.valid.subscriptionPlan &&
                    this.valid.country &&
                    this.valid.name &&
                    this.valid.app_name &&
                    this.valid.address &&
                    this.valid.email &&
                    this.valid.vatNumber &&
                    this.valid.primaryPhone &&
                    this.valid.tos &&
                    this.valid.fullname &&
                    this.valid.mobile &&
                    this.valid.countryCode
                );
            } else {
                return (
                    this.valid.subscriptionPlan &&
                    this.valid.country &&
                    this.valid.name &&
                    this.valid.app_name &&
                    this.valid.address &&
                    this.valid.email &&
                    this.valid.vatNumber &&
                    this.valid.primaryPhone
                );
            }
        }
    },

    methods: {
        validateSubscriptionPlan() {
            if (!this.store.store_subscription_plan_id) {
                this.error.subscriptionPlan = this.errorMessages.subscriptionPlanRequired[
                    this.lang
                ];
            } else {
                this.error.subscriptionPlan = "";
            }
        },

        validateCountry() {
            if (!this.store.country_id) {
                this.error.country = this.errorMessages.countryRequired[
                    this.lang
                ];
            } else {
                if (this.store.vat_number) {
                    this.validateVatNumber()
                }
                this.error.country = "";
            }
        },

        validateName() {
            if (!this.store.name) {
                this.error.name = this.errorMessages.nameRequired[this.lang];
            } else if (this.store.name.length < 5) {
                this.error.name = this.errorMessages.nameLength[this.lang];
            } else {
                this.error.name = "";
            }
        },

        validateAppName() {
            if (!this.store.app_name) {
                this.error.app_name = this.errorMessages.appNameRequired[
                    this.lang
                ];
            } else {
                this.error.app_name = "";
            }
        },

        validateAddress() {
            if (!this.store.address && (!this.store.lat || !this.store.lon)) {
                this.error.address = this.errorMessages.addressRequired[
                    this.lang
                ];
            } else if (
                !this.isAddress &&
                (!this.store.lat || !this.store.lon)
            ) {
                this.error.address = this.errorMessages.addressIsPostal[
                    this.lang
                ];
            } else {
                this.error.address = "";
            }
        },

        async validateVatNumber() {
            let isValid = false;
            this.error.vatNumber = "";
            if (!this.store.vat_number) {
                this.error.vatNumber = this.errorMessages.vatNumberRequired[
                    this.lang
                ];
                isValid = false;
            } else if (this.store.vat_number.length < 9 || this.store.vat_number.length > 12) {
                this.error.vatNumber = this.errorMessages.vatNumberLength[
                    this.lang
                ];
                isValid = false;
            } else if (this.store.vat_number?.length >= 9) {
                let res = await this.checkVatNumber({
                    afm: this.store.vat_number,
                    country_id: this.store.country_id
                });
                if (res.data?.status === 'success') {
                    this.error.vatNumber = "";
                    isValid = true;
                } else if (res.data?.error) {
                    this.error.vatNumber = res.data?.message || "";
                    isValid = false;
                }
            }
            return isValid;
        },

        validateEmail() {
            if (!this.store.email) {
                this.error.email = this.errorMessages.emailRequired[this.lang];
            } else if (!/.+@.+/.test(this.store.email)) {
                this.error.email = this.errorMessages.emailValid[this.lang];
            } else {
                this.error.email = "";
            }
        },

        validatePrimaryPhone() {
            if (!this.store.primary_phone) {
                this.error.primaryPhone = this.errorMessages.primaryPhoneRequired[
                    this.lang
                ];
            } else if (this.store.primary_phone.length  < 7 ||  this.store.primary_phone.length > 12) {
                this.error.primaryPhone = this.errorMessages.primaryPhoneLength[
                    this.lang
                ];
            } else {
                this.error.primaryPhone = "";
            }
        },

        validateFullname() {
            if (!this.userDetails.full_name) {
                this.error.fullname = this.errorMessages.fullnameRequired[
                    this.lang
                ];
            } else {
                this.error.fullname = "";
            }
        },

        validateMobile() {
            if (!this.userDetails.mobile) {
                this.error.mobile = this.errorMessages.mobileRequired[
                    this.lang
                ];
            } else if (this.userDetails.mobile.length < 7 ||  this.userDetails.mobile.length > 12) {
                this.error.mobile = this.errorMessages.mobileLength[this.lang];
            } else {
                this.error.mobile = "";
                this.validateCountryCode();
            }
        },
        validateCountryCode() {
            this.valid.countryCode = !!this.userDetails.country_id;
            this.success.countryCode = !!this.userDetails.country_id;
            if (!this.userDetails.country_id) {
                this.error.countryCode = this.errorMessages.countryCodeRequired[
                    this.lang
                ];
            } else  {
                this.error.countryCode = "";
            }
        },
    },

    watch: {
        ["store.store_subscription_plan_id"]: {
            immediate: true,
            handler(val) {
                this.valid.subscriptionPlan = !!val;
                this.success.subscriptionPlan = !!val;
            }
        },

        ["store.country_id"]: {
            immediate: true,
            handler(val) {
                this.valid.country = !!val;
                this.success.country = !!val;
            }
        },

        ["store.name"]: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.valid.name = val.length >= 5;
                    this.success.name = val.length >= 5;
                } else {
                    this.valid.name = false;
                    this.success.name = false;
                }
            }
        },

        ["store.app_name"]: {
            immediate: true,
            handler(val) {
                this.valid.app_name = !!val;
                this.success.app_name = !!val;
            }
        },

        ["store.address"]: {
            immediate: true,
            handler(val) {
                if (val && this.isAddress) {
                    this.valid.address = true;
                    this.success.address = true;
                } else if (
                    !(val && this.isAddress) &&
                    (!this.store.lat || !this.store.lon)
                ) {
                    this.valid.address = false;
                    this.success.address = false;
                }
            }
        },

        ["store.lat"]: {
            immediate: true,
            handler(val) {
                if (val && this.store.lon) {
                    this.valid.address = true;
                    this.success.address = true;
                    this.error.address = "";
                } else if (!this.store.address) {
                    this.valid.address = false;
                    this.success.address = false;
                }
            }
        },

        ["store.lon"]: {
            immediate: true,
            handler(val) {
                if (val && this.store.lat) {
                    this.valid.address = true;
                    this.success.address = true;
                    this.error.address = "";
                } else if (!this.store.address) {
                    this.valid.address = false;
                    this.success.address = false;
                }
            }
        },

        ["store.vat_number"]: {
            immediate: true,
            async handler(val) {
                if (val?.length >= 9) {
                    let isValid = await this.validateVatNumber();
                    this.valid.vatNumber = isValid;
                    this.success.vatNumber = isValid;
                } else {
                    this.valid.vatNumber = false;
                    this.success.vatNumber = false;
                }
            }
        },

        ["store.email"](val) {
            this.valid.email = /.+@.+/.test(val);
            this.success.email = /.+@.+/.test(val);
        },

        ["store.primary_phone"]: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.valid.primaryPhone = val.length === 10;
                    this.success.primaryPhone = val.length === 10;
                } else {
                    this.valid.primaryPhone = false;
                    this.success.primaryPhone = false;
                }
            }
        },

        ["userDetails.tos"]: {
            immediate: true,
            handler(val) {
                this.valid.tos = !!val;
                this.success.tos = !!val;
            }
        },

        ["userDetails.marketing"]: {
            immediate: true,
            handler(val) {
                this.valid.marketing = !!val;
                this.success.marketing = !!val;
            }
        },

        ["userDetails.full_name"]: {
            immediate: true,
            handler(val) {
                this.valid.fullname = !!val;
                this.success.fullname = !!val;
            }
        },

        ["userDetails.mobile"]: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.valid.mobile = (val.length >= 7 && val.length <= 12);
                    this.success.mobile = (val.length >= 7 && val.length <= 12);
                } else {
                    this.valid.mobile = false;
                    this.success.mobile = false;
                }
            }
        },
        ["userDetails.country_id"]: {
            immediate: true,
            handler(val) {
                this.valid.countryCode = !!val;
                this.success.countryCode = !!val;
             
            }
        },

        resetSuccess(val) {
            if (val) {
                this.success = {
                    subscriptionPlan: false,
                    country: false,
                    name: false,
                    app_name: false,
                    address: false,
                    vatNumber: false,
                    email: false,
                    primaryPhone: false,
                    tos: false,
                    marketing: false,
                    fullname: false,
                    mobile: false,
                    countryCode: false
                };

                this.setResetSuccess(false);
            }
        },

        resetValidation: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.error = {
                        subscriptionPlan: "",
                        country: "",
                        name: "",
                        app_name: "",
                        address: "",
                        vatNumber: "",
                        email: "",
                        primaryPhone: "",
                        tos: "",
                        marketing: "",
                        fullname: "",
                        mobile: "",
                        countryCode: ""
                    };

                    this.setResetValidation(false);
                }
            }
        }
    }
};
